module.exports={select:"選択",selected:"選 択済み"};